module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-touch', {
    on: {
      "tap": function($event) {
        return _vm.$emit('eventClicked', _vm.event.obj)
      }
    }
  }, [_c('div', {
    staticClass: "day-cal__event",
    class: {
      'day-cal__event--is-canceled': _vm.event.obj.canceled
    },
    style: (_vm.styleObject)
  }, [(_vm.event.obj.away || _vm.event.obj.canceled) ? _c('div', {
    staticClass: "d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning",
    class: {
      'd-cal__event-meta__fixed--canceled': _vm.event.obj.canceled
    }
  }, [(_vm.event.obj.canceled) ? _c('span', {
    staticClass: "icon-notification22"
  }) : _c('svg', {
    staticClass: "tw-icon tw-icon--warning",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
    }
  })]), _vm._v("\n      " + _vm._s(_vm.getEventWarningLabel(_vm.event.obj)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "day-cal__event__content"
  }, [_c('span', [_vm._v(_vm._s(_vm.event.obj.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$filters.timeStamp(_vm.event.obj.start)) + " - " + _vm._s(_vm.$filters.timeStamp(_vm.event.obj.end)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.event.obj.has_notes),
      expression: "event.obj.has_notes"
    }],
    staticClass: "notes-icon icon-file-text2"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.event.obj.group),
      expression: "event.obj.group"
    }]
  }, [_c('span', {
    staticClass: "icon-users"
  }), _vm._v(" " + _vm._s(_vm.event.obj.group))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.event.obj.teacher),
      expression: "event.obj.teacher"
    }]
  }, [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.event.obj.teacher))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.event.obj.room),
      expression: "event.obj.room"
    }]
  }, [_c('span', {
    staticClass: "icon-location"
  }), _vm._v(" " + _vm._s(_vm.event.obj.room))])]), _vm._v(" "), _c('div', {
    staticClass: "day-cal__event__bg",
    style: ({
      backgroundColor: _vm.event.obj.color
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "day-cal__event__sider",
    style: ({
      backgroundColor: _vm.event.obj.color
    })
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bbeecbae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/DayCal/DayCalEvent.vue
// module id = 2107
// module chunks = 1